export default __webpack_public_path__ + "static/media/fsm.ebfa0354.png";